import {
  FILTER_EQUIPMENT_VISIBILITY_DEFAULT,
  FILTER_EQUIPMENT_VISIBILITY_STORAGE_KEY
} from 'react/components/RouteMonitor/EquipmentStatusCaption/constants';
/**
 * Classe pra acessar as funcionalidades de local storage
 */


Greenmile.Storage = Greenmile.Storage || {};

Greenmile.Storage.clearUserData = function () {
    const allowedSessionStorageItems = ['getItem', 'setItem', 'clear'];
    const sessionsItemsToClear = [
        'User',
        'ApplicationLoad',
        'UserPreferences',
        'Configurations',
    ];

    Object.keys(Monet.Session.sessionStorage)
        .filter(key => !allowedSessionStorageItems.includes(key))
        .forEach(key => delete Monet.Session.sessionStorage[key]);

    sessionsItemsToClear.forEach(item => Monet.Session[item] = {});
};

Greenmile.Storage.StoreMapPosition = function () {

    this.isUpdateKey = 'isUpdated'

    this.storageIsChanged = function () {
        const key = this.isUpdateKey;
        
        Monet.Session.sessionStorage.setItem(key, "false");
    };

    this.setIsUpdated = function () {
        const key = this.isUpdateKey;

        Monet.Session.sessionStorage.setItem(key, "true");
    };

    this.isUpdate = function () {

        var isUpdated = Monet.Session.sessionStorage.getItem('isUpdated');

        if (isUpdated) {
            isUpdated = JSON.parse(isUpdated);
        }

        return isUpdated;
    };

    this.setPosition = function (coordinates, zoom) {

        const key = "mapmain";
        const data = Greenmile.UserPreferences.Default.getDefaultPreferences().mapmain;

        if (coordinates && zoom && coordinates.lat !== "" && zoom > 0) {

            data.center = coordinates;
            data.zoom = zoom;

            Monet.Session.sessionStorage.setItem(key, JSON.stringify(data));
        }

        this.storageIsChanged();

    };

    this.getPosition = function () {

        var key = "mapmain";
        var data = Monet.Session.sessionStorage.getItem(key);

        if (data) {
            return JSON.parse(data);
        }

        return null;
    };

    this.setSupplierMapFromUser = function (resource) {

        var keyMap = "supplierMap";
        var dataMap = Greenmile.UserPreferences.Default.getDefaultPreferences().supplierMap;

        if (resource) {
            dataMap.supplier_map = resource;
        }

        Monet.Session.sessionStorage.setItem(keyMap, JSON.stringify(dataMap));
        this.storageIsChanged();


    };

    this.setEquipmentTagFromUser = function (objectEquipmentTag) {
        const keyEquipmentTag = "equipmentTag";
        const userPreferences = new Greenmile.UserPreferences.Actions();

        Monet.Session.sessionStorage.setItem(keyEquipmentTag, JSON.stringify(objectEquipmentTag));
        userPreferences.saveOrUpdateSingleUserPreference(keyEquipmentTag);
        this.storageIsChanged();

    };

    this.createListEquipmentTags = function () {

        return Monet.Session.TagList.Equipment.map((tag) => {
            return { id: tag.id, value: false };
        });

    };

    this.updateEquipmentTags = function (selectedEquipmentsArray, selectorText) {
        const selectorTextAppend = selectorText ? selectorText + '-' : '';

        var equipmentsOnLocalStorage = this.getEquipmentTagFromUser(), idEquipment = '';

        if (selectedEquipmentsArray) {

            for (var i = 0, size = selectedEquipmentsArray.length; i < size; i++) {

                for (var j = 0, size2 = equipmentsOnLocalStorage.length; j < size2; j++) {

                    idEquipment = selectedEquipmentsArray[i].id.replace("EQUIPMENT-" + selectorTextAppend, "");
                    const checkboxEquipment = document.getElementById('EQUIPMENT-' + selectorTextAppend + equipmentsOnLocalStorage[j].id);

                    if (idEquipment === equipmentsOnLocalStorage[j].id.toString()) {
                        equipmentsOnLocalStorage[j].value = true;
                    } else if (checkboxEquipment && !checkboxEquipment.checked) {
                        equipmentsOnLocalStorage[j].value = false;
                    }

                }

            }

        } else {
            equipmentsOnLocalStorage = this.createListEquipmentTags();
        }

        this.setEquipmentTagFromUser(equipmentsOnLocalStorage);

    };

    this.checkEquipmentsOnLocalStorage = function () {

        var newEquipmentTags         = this.createListEquipmentTags(),
            equipmentsOnLocalStorage = this.getEquipmentTagFromUser();

        for (var i = 0, size = newEquipmentTags.length; i < size; i++) {

            for (var j = 0, sizeEqLS = equipmentsOnLocalStorage.length; j < sizeEqLS; j++) {

                if (newEquipmentTags[i].id === equipmentsOnLocalStorage[j].id) {
                    newEquipmentTags[i].value = equipmentsOnLocalStorage[j].value;
                }

            }

        }

        this.setEquipmentTagFromUser(newEquipmentTags);
    };

    this.getEquipmentsTagsMarked = function () {

        var equipmentsOnLocalStorage = this.getEquipmentTagFromUser(), equipmentsMarked = [];

        if(equipmentsOnLocalStorage) {
            for (var j = 0, sizeEqLS = equipmentsOnLocalStorage.length; j < sizeEqLS; j++) {

                if (equipmentsOnLocalStorage[j].value) {
                    equipmentsMarked.push(equipmentsOnLocalStorage[j]);

                }

            }
        }

        return equipmentsMarked;
    };

    this.setGeofenceTagFromUser = function (objectGeofenceTag, selectorText) {
        const keyGeofenceTag = "geofenceTag";
        const userPreferences = new Greenmile.UserPreferences.Actions();
        let geofenceTagsToStore = null;

        if (selectorText) {
            const storedGeofenceTags = this.getAllGeofenceTagFromUser();
            if (storedGeofenceTags) {
                storedGeofenceTags[selectorText] = objectGeofenceTag;
                geofenceTagsToStore = storedGeofenceTags;
            } else {
                geofenceTagsToStore = {
                    [selectorText]: objectGeofenceTag
                };
            }
        } else {
            geofenceTagsToStore = objectGeofenceTag;
        }

        if(geofenceTagsToStore) {
            for (let key in geofenceTagsToStore) {
                const isStandardGeofenceTag = key.includes('routeDetailMap') || key.includes('routeMonitorRightPanelBody');
                if(isStandardGeofenceTag) {
                    const geofenceTag = geofenceTagsToStore[key];
                    const sanityzedGeofenceTag = geofenceTag.filter( tag => tag.value === true );
                    geofenceTagsToStore[key] = sanityzedGeofenceTag;
                } else {
                    delete geofenceTagsToStore[key];
                }                
            }
        }
        Monet.Session.sessionStorage.setItem(keyGeofenceTag, JSON.stringify(geofenceTagsToStore));
        userPreferences.saveOrUpdateSingleUserPreference(keyGeofenceTag);
        this.storageIsChanged();
    };

    this.createListGeofencetTags = function () {

        var object = [];
        Monet.Session.TagList.Geofence.tagsList.forEach(function (tag) {
            object.push({ id: tag.id, value: false });
        });

        return object;
    };

    this.updateGeofenceTags = function (selectedGeofencesArray, selectorText, geofenceObjName) {
        const selectorTextAppend = selectorText ? selectorText + '-' : '';
        let idGeofence = '';
        let geofencesOnLocalStorage = this.createListGeofencetTags();

        if (selectedGeofencesArray) {

            for (var i = 0, size = selectedGeofencesArray.length; i < size; i++) {

                for (var j = 0, size2 = geofencesOnLocalStorage.length; j < size2; j++) {

                    idGeofence = selectedGeofencesArray[i].id.replace("GEOFENCE-" + selectorTextAppend, "");
                    const checkboxGeofence = document.getElementById('GEOFENCE-' + selectorTextAppend + geofencesOnLocalStorage[j].id);

                    if (idGeofence === geofencesOnLocalStorage[j].id.toString()) {
                        geofencesOnLocalStorage[j].value = true;
                    } else if (checkboxGeofence && !checkboxGeofence.checked) {
                        geofencesOnLocalStorage[j].value = false;
                    }

                }

            }

        } else {
            geofencesOnLocalStorage = this.createListGeofencetTags();
        }
        this.setGeofenceTagFromUser(geofencesOnLocalStorage, geofenceObjName);

    };

    this.checkGeofencesOnLocalStorage = function (selectorText) {

        var newGeofenceTags         = this.createListGeofencetTags(),
            geofencesOnLocalStorage = this.getGeofenceTagFromUser(selectorText);

        for (var i = 0, size = newGeofenceTags.length; i < size; i++) {

            for (var j = 0, sizeEqLS = geofencesOnLocalStorage.length; j < sizeEqLS; j++) {

                if (newGeofenceTags[i].id === geofencesOnLocalStorage[j].id) {
                    newGeofenceTags[i].value = geofencesOnLocalStorage[j].value;
                }

            }

        }

        this.setGeofenceTagFromUser(newGeofenceTags, selectorText);
    };

    this.getGeofencesTagsMarked = function (selectorText) {

        var geofencesOnLocalStorage = this.getGeofenceTagFromUser(selectorText) || [], geofencesMarked = [];

        for (var j = 0, sizeEqLS = geofencesOnLocalStorage.length; j < sizeEqLS; j++) {

            if (geofencesOnLocalStorage[j].value) {
                geofencesMarked.push(geofencesOnLocalStorage[j]);
            }

        }

        return geofencesMarked;

    };

    this.getSupplierMapFromUser = function () {

        var keyMap = "supplierMap";
        var dataMap = Monet.Session.sessionStorage.getItem(keyMap);
        var notEmpty = this.objNotEmpty(dataMap);

        if (notEmpty && dataMap) {
            return JSON.parse(dataMap);
        }

        return null;

    };

    this.getPOIsFromUser = function () {

        var keyPOIs = "POIs";
        var layerMap = Monet.Session.sessionStorage.getItem(keyPOIs);

        if (layerMap) {
            return JSON.parse(layerMap);
        }

        return null;
    };

    this.setPOIsFromUser = function (obj) {
        const keyPOIs = "POIs";
        const userPreferences = new Greenmile.UserPreferences.Actions();

        obj = obj.filter(item => item.value === true);

        Monet.Session.sessionStorage.setItem(keyPOIs, JSON.stringify(obj));
        userPreferences.saveOrUpdateSingleUserPreference(keyPOIs);
        this.storageIsChanged();

    };

    this.updatePOIs = function (POIsSelected) {

        let POIsOnLocalStorage = this.getPOIsFromUser();
        const chekId = parseInt(POIsSelected.id.replace(/.+?_/, ""));

        if (POIsSelected) {
            const hasPoiOnLocalStorage = POIsOnLocalStorage.some(poi => poi.id === chekId && poi.value === true);

            if(hasPoiOnLocalStorage) {
                POIsOnLocalStorage = POIsOnLocalStorage.filter(poi => poi.id !== chekId);
            } else {
                const item = { id: chekId, value: true };
                POIsOnLocalStorage.push(item);
            }

        }

        this.setPOIsFromUser(POIsOnLocalStorage);
    };

    this.checkPOIsOnLocalStorage = function () {

        var newPOIs            = this.createListPOIs(),
            POIsOnLocalStorage = this.getPOIsFromUser();

        for (var i = 0, size = newPOIs.length; i < size; i++) {

            for (var j = 0, sizeEqLS = POIsOnLocalStorage.length; j < sizeEqLS; j++) {

                if (newPOIs[i].id === POIsOnLocalStorage[j].id) {
                    newPOIs[i].value = POIsOnLocalStorage[j].value;
                }

            }

        }

        this.setPOIsFromUser(newPOIs);
    };

    this.createListPOIs = function () {

        var object = [];

        for (var i = 0, size = Monet.Session.POIs.length; i < size; i++) {
            object.push({ id: Monet.Session.POIs[i].id, value: false });
        }

        return object;
    };

    this.getPOIsMarked = function () {

        var POIsOnLocalStorage = this.getPOIsFromUser(), POIsMarked = [];

        if (POIsOnLocalStorage) {

            for (var j = 0, sizeEqLS = POIsOnLocalStorage.length; j < sizeEqLS; j++) {

                if (POIsOnLocalStorage[j].value) {
                    POIsMarked.push(POIsOnLocalStorage[j]);
                }

            }

        }

        return POIsMarked;
    };

    this.getLayerMapFromUser = function () {

        var layerMap = Monet.Session.sessionStorage.getItem("layerMap");

        if (layerMap) {
            return JSON.parse(layerMap);
        }

        return null;

    };

    this.setLayerMapFromUser = function (obj) {

        const keyMap = "layerMap";
        const layerMap = this.getLayerMapFromUser();
        const routesCheck = Greenmile.UserPreferences.Default.getDefaultPreferences().layerMap;
        const userPreferences = new Greenmile.UserPreferences.Actions();

        if (layerMap && obj) {

            Monet.Session.sessionStorage.setItem(keyMap, JSON.stringify(obj));
            userPreferences.saveOrUpdateSingleUserPreference(keyMap);
            this.storageIsChanged();

        } else if (layerMap) {

            return routesCheck;

        } else {

            Monet.Session.sessionStorage.setItem(keyMap, JSON.stringify(routesCheck));
            userPreferences.saveOrUpdateSingleUserPreference(keyMap);
            this.storageIsChanged();

        }

    };

    this.getEquipmentTagFromUser = function () {

        var keyEquipmentTag = "equipmentTag";
        var equipmentTag = Monet.Session.sessionStorage.getItem(keyEquipmentTag);

        if (equipmentTag) {
            return JSON.parse(equipmentTag);
        }

        return null;

    };

    this.getAllGeofenceTagFromUser = function () {

        const keyGeofenceTag = "geofenceTag";
        const geofenceTags = Monet.Session.sessionStorage.getItem(keyGeofenceTag);
        
        if (geofenceTags) {
            const geofenceTagsJson =  JSON.parse(geofenceTags);
            if(Array.isArray(geofenceTagsJson)) {
                return {};
            }
            return geofenceTagsJson;
        }

        return null;

    };

    this.getGeofenceTagFromUser = function (selectorText) {

        const keyGeofenceTag = "geofenceTag";
        const geofenceTags = Monet.Session.sessionStorage.getItem(keyGeofenceTag);
        
        if (geofenceTags) {
            const geofenceTagsJson = JSON.parse(geofenceTags);
            if (selectorText) {
                return geofenceTagsJson[selectorText] || [];
            }
            return geofenceTagsJson;
        }

        return [];

    };

    this.objNotEmpty = function (obj) {

        for (var prop in obj) {

            if (obj.hasOwnProperty(prop)) {
                return true;
            }

        }

        return false;

    };

    this.checkRadioButtonLayerMapRouteDetail = function () {

        var storeMap = new Greenmile.Storage.StoreMapPosition()
            .getSupplierMapFromUser();
        var aba = Monet.Utils.GetTabName();

        if (storeMap) {

            $("#" + aba + " input[type=radio]."+ storeMap.supplier_map).prop(
                'checked', true);
        }

    };

    this.setShowGridRouteDetailFromUser = function (show) {

        const keyMap = "showGridRouteDetail";
        const actualStateInStorage = 
            JSON.parse(Monet.Session.sessionStorage.getItem(keyMap)) || {};
        
        if (actualStateInStorage?.show_grid === show) {
            return;
        }
        
        const userPreferences = new Greenmile.UserPreferences.Actions();
        const dataMap = {
            show_grid: true
        };

        if (!show) {
            dataMap.show_grid = false;
        }

        Monet.Session.sessionStorage.setItem(keyMap, JSON.stringify(dataMap));
        userPreferences.saveOrUpdateSingleUserPreference(keyMap);
    };

    this.getShowGridRouteDetailFromUser = function () {

        var keyMap = "showGridRouteDetail";
        var dataMap = Monet.Session.sessionStorage.getItem(keyMap);
        var notEmpty = this.objNotEmpty(dataMap);

        if (notEmpty && dataMap) {
            return JSON.parse(dataMap);
        }

        return null;

    };

    this.setTrackEquipmentPreferencies = function (preferences) {

        const keyMap = "TrackEquipment";
        const userPreferences = new Greenmile.UserPreferences.Actions();

        if (preferences) {
            Monet.Session.sessionStorage.setItem(keyMap, JSON.stringify(preferences));
            userPreferences.saveOrUpdateSingleUserPreference(keyMap);
        }

        this.storageIsChanged();

    };

    this.getTrackEquipmentPreferencies = function () {

        var keyMap = "TrackEquipment";
        var dataMap = Monet.Session.sessionStorage.getItem(keyMap);
        var notEmpty = this.objNotEmpty(dataMap);

        if (notEmpty && dataMap) {
            return JSON.parse(dataMap);
        }

        return {};

    };

    this.setHeightTabsRouteDetailFromUser = function (height) {

        const keyMap = "heightTabsRouteDetail";
        const userPreferences = new Greenmile.UserPreferences.Actions();
        const dataMap = {
            height: height
        };

        Monet.Session.sessionStorage.setItem(keyMap, JSON.stringify(dataMap));
        userPreferences.saveOrUpdateSingleUserPreference(keyMap);

        this.storageIsChanged();

    };

    this.getHeightTabsRouteDetailFromUser = function () {

        var keyMap = "heightTabsRouteDetail";
        var dataMap = Monet.Session.sessionStorage.getItem(keyMap);
        var notEmpty = this.objNotEmpty(dataMap);

        if (notEmpty && dataMap) {
            return JSON.parse(dataMap);
        }

        return null;

    };

    this.getHOSMapFromUser = function () {

        var keyMap = "HOS";
        var preferenceHOS = Monet.Session.sessionStorage.getItem(keyMap);

        if (preferenceHOS && preferenceHOS !== "undefined") {
            return JSON.parse(preferenceHOS);
        }

        return null;

    };

    this.setHOSMapFromUser = function (obj) {

        const preferencesDefault = Greenmile.UserPreferences.Default.getDefaultPreferences();
        const userPreferences = new Greenmile.UserPreferences.Actions();
        const keyMap = "HOS";
        const hosMap = this.getHOSMapFromUser();
        let hosCheck;

        if (hosMap && obj) {

            Monet.Session.sessionStorage.setItem(keyMap, JSON.stringify(obj));
            userPreferences.saveOrUpdateSingleUserPreference(keyMap);
            this.storageIsChanged();

        } else {

            hosCheck = preferencesDefault.HOS;
            Monet.Session.sessionStorage.setItem(keyMap, JSON.stringify(hosCheck));
            userPreferences.saveOrUpdateSingleUserPreference(keyMap);
            this.storageIsChanged();

            return hosCheck;
        }

    };

    this.getSideBarExpandFromUser = function () {
        var preferenceSideBar = Monet.Session.sessionStorage.getItem('sidebar');

        if (preferenceSideBar) {
            return JSON.parse(preferenceSideBar);
        }

        return [];

    };

    this.setSideBarExpandFromUser = function (screen, show) {

        const keyMap = "sidebar";
        const sidebarMap = this.getSideBarExpandFromUser();
        const object = [];
        const userPreferences = new Greenmile.UserPreferences.Actions();

        if (Array.isArray(sidebarMap) && screen) {

            const index = this.existScreenOnLocalStorage(screen);

            if (index >= 0) {
                sidebarMap[index].show = show;
            } else {
                sidebarMap.push({ screen: screen, show: show });
            }

            Monet.Session.sessionStorage.setItem(keyMap, JSON.stringify(sidebarMap));
            userPreferences.saveOrUpdateSingleUserPreference(keyMap);
            this.storageIsChanged();

        } else {

            object.push({ screen: screen, show: show });
            Monet.Session.sessionStorage.setItem(keyMap, JSON.stringify(object));
            userPreferences.saveOrUpdateSingleUserPreference(keyMap);
            this.storageIsChanged();

        }

    };

    this.setAutoRefreshStatus = function (status) {
        const keyMap = "autoRefreshIsEnabled";
        const userPreferences = new Greenmile.UserPreferences.Actions();

        Monet.Session.sessionStorage.setItem(keyMap, status);
        userPreferences.saveOrUpdateSingleUserPreference(keyMap);
        this.storageIsChanged();
    }

    this.getAutoRefreshStatus = function () {
        const autoRefreshStatus = Monet.Session.sessionStorage.getItem("autoRefreshIsEnabled");

        if(autoRefreshStatus) {
            return autoRefreshStatus
        }

        return false;
    }

    this.checkScreenOnLocalStorage = function (screen) {

        var sidebarOnLocalStorage = this.getSideBarExpandFromUser();

        for (var i = 0, size = sidebarOnLocalStorage.length; i < size; i++) {

            if (sidebarOnLocalStorage[i].screen === screen) {
                return sidebarOnLocalStorage[i];
            }

        }

        return null;
    };

    this.existScreenOnLocalStorage = function (screen) {

        var sidebarOnLocalStorage = this.getSideBarExpandFromUser();

        for (var i = 0, size = sidebarOnLocalStorage.length; i < size; i++) {

            if (sidebarOnLocalStorage[i].screen === screen) {
                return i;
            }

        }

    };

    this.setPinnedMenusFromUser = function (pinnedMenus) {
        const keyMap = 'pinnedMenus';
        const userPreferences = new Greenmile.UserPreferences.Actions();

        Monet.Session.sessionStorage.setItem(keyMap, JSON.stringify(pinnedMenus));
        userPreferences.saveOrUpdateSingleUserPreference(keyMap);
        this.storageIsChanged();
    }

    this.getPinnedMenusFromUser = function () {
        const pinnedMenus = Monet.Session.sessionStorage.getItem('pinnedMenus');

        return pinnedMenus ? JSON.parse(pinnedMenus) : [];
    }

    this.setEquipmentVisibilityFilterOption = function(option) {
        Monet.Session.sessionStorage.setItem(
          FILTER_EQUIPMENT_VISIBILITY_STORAGE_KEY,
          option
        );
    };

    this.getEquipmentVisibilityFilterOption = function () {
      const value = Monet.Session.sessionStorage.getItem(
        FILTER_EQUIPMENT_VISIBILITY_STORAGE_KEY
      );
      return value || FILTER_EQUIPMENT_VISIBILITY_DEFAULT;
    };
};
